/** Test CI platform chosen after the test branch during onboarding. */
export type PipelinePlatform = 'ado' | 'github-actions' | 'jenkins';

export const PIPELINE_PLATFORM_OPTIONS: {
  value: PipelinePlatform;
  label: string;
}[] = [
  { value: 'ado', label: 'Azure Pipelines' },
  { value: 'github-actions', label: 'GitHub Actions' },
  { value: 'jenkins', label: 'Jenkins' },
];

export function pipelinePlatformLabel(
  platform: PipelinePlatform | '' | null | undefined,
): string {
  if (!platform) return '';
  return (
    PIPELINE_PLATFORM_OPTIONS.find(o => o.value === platform)?.label ?? platform
  );
}
